import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-primary flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-lg mx-auto text-center">
        <h1 className="text-8xl md:text-9xl font-display text-accent leading-none mb-4">
          404
        </h1>

        <h2 className="text-2xl md:text-3xl font-display uppercase tracking-wide text-white mb-3">
          Page Not Found
        </h2>

        <p className="text-white/60 font-body mb-10">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 font-display uppercase tracking-wide text-white border border-white/30 hover:border-white/60 rounded transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 font-display uppercase tracking-wide text-primary bg-accent hover:bg-accent-hover rounded transition-colors font-bold"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
